import { FormModel } from '../core/form-model.class';
import { CreateDeviceDto } from '@shared/common/device/create-device.dto';

export class DeviceFormModel extends FormModel(CreateDeviceDto) {
    public labels: any = {
        label: 'Libellé',
        tagId: 'Tag',
        ownerId: 'Propriétaire',
        phoneNumber: 'N° Tél',
        baseSubscriptionId: 'Programmation',
        subscriptionStart: 'Début d\'abonnement',
        subscriptionEnd: 'Fin d\'abonnement',
        pinCode: 'Code pin',
    };
}
